import { NgModule } from '@angular/core';
import { PaymentsConvertersModule } from './converters';
import { PaymentStoreModule } from './store/payment-store.module';

@NgModule({
  imports: [PaymentStoreModule, PaymentsConvertersModule],
})
export class PaymentDataAccessModule {}
